module.exports = __webpack_public_path__ + "img/blue-ticket-icon.3ded19da.svg";